<template>
  <div class="login-container">
    <!-- 背景装饰 -->
    <div class="background-effects">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
      <div class="grid-overlay"></div>
    </div>

    <!-- 登录卡片 - 横版布局 -->
    <div class="login-card">
      <!-- 左侧品牌展示区域 -->
      <div class="brand-section">
        <div class="logo-section">
          <div class="logo-icon">
            <i class="fas fa-shield-alt"></i>
          </div>
          <div class="logo-text">
            <h1 class="logo-title">AI全球播</h1>
            <p class="logo-subtitle">开启直播2.0时代</p>
          </div>
        </div>

        <!-- 平台选择 -->
        <div class="platform-section">
          <p class="section-title">选择平台</p>
          <div class="platform-grid">
            <button
                class="platform-btn"
                :class="{ active: loginForm.platform_type === 'douyin' }"
                @click="loginForm.platform_type = 'douyin'"
            >
              <div class="platform-icon douyin-icon">
                <i class="fas fa-layer-group"></i>
              </div>
              <span>D音</span>
            </button>
            <button
                class="platform-btn"
                :class="{ active: loginForm.platform_type === 'tiktok' }"
                @click="loginForm.platform_type = 'tiktok'"
            >
              <div class="platform-icon tiktok-icon">
                <i class="fas fa-microchip"></i>
              </div>
              <span>TK</span>
            </button>
            <button
                class="platform-btn"
                :class="{ active: loginForm.platform_type === 'douyin-tg' }"
                @click="loginForm.platform_type = 'douyin-tg'"
            >
              <div class="platform-icon douyin-tg-icon">
                <i class="fas fa-shapes"></i>
              </div>
              <span>D音团购</span>
            </button>
            <button
                class="platform-btn"
                :class="{ active: loginForm.platform_type === 'kuaishou' }"
                @click="loginForm.platform_type = 'kuaishou'"
            >
              <div class="platform-icon kuaishou-icon">
                <i class="fas fa-wind"></i>
              </div>
              <span>K手</span>
            </button>
            <button
                class="platform-btn"
                :class="{ active: loginForm.platform_type === 'kuaishou-tg' }"
                @click="loginForm.platform_type = 'kuaishou-tg'"
            >
              <div class="platform-icon kuaishou-tg-icon">
                <i class="fas fa-cubes"></i>
              </div>
              <span>K手团购</span>
            </button>
            <button
                class="platform-btn"
                :class="{ active: loginForm.platform_type === 'weixin' }"
                @click="loginForm.platform_type = 'weixin'"
            >
              <div class="platform-icon weixin-icon">
                <i class="fas fa-wave-square"></i>
              </div>
              <span>S号</span>
            </button>
            <button
                class="platform-btn"
                :class="{ active: loginForm.platform_type === 'pinduoduo' }"
                @click="loginForm.platform_type = 'pinduoduo'"
            >
              <div class="platform-icon pinduoduo-icon">
                <i class="fas fa-gem"></i>
              </div>
              <span>拼夕夕</span>
            </button>
            <button
                class="platform-btn"
                :class="{ active: loginForm.platform_type === 'taobao' }"
                @click="loginForm.platform_type = 'taobao'"
            >
              <div class="platform-icon taobao-icon">
                <i class="fas fa-box"></i>
              </div>
              <span>T宝</span>
            </button>
            <button
                class="platform-btn"
                :class="{ active: loginForm.platform_type === 'meituan' }"
                @click="loginForm.platform_type = 'meituan'"
            >
              <div class="platform-icon meituan-icon">
                <i class="fas fa-compass"></i>
              </div>
              <span>M团</span>
            </button>
            <button
                class="platform-btn"
                :class="{ active: loginForm.platform_type === 'jd' }"
                @click="loginForm.platform_type = 'jd'"
            >
              <div class="platform-icon jd-icon">
                <i class="fas fa-paper-plane"></i>
              </div>
              <span>J东</span>
            </button>

          </div>
        </div>

        <div class="brand-features">
          <div class="feature-item">
            <i class="fas fa-video"></i>
            <span>智能直播中控</span>
          </div>
          <div class="feature-item">
            <i class="fas fa-headphones"></i>
            <span>专业音频处理</span>
          </div>
          <div class="feature-item">
            <i class="fas fa-globe"></i>
            <span>多平台支持</span>
          </div>
        </div>
      </div>

      <!-- 右侧登录表单区域 -->
      <div class="login-section">
        <div class="login-body">
          <!-- 登录表单 -->
          <form v-if="!showRegisterForm" @submit.prevent="handleLogin" class="login-form">
            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-user"></i>
                <span>账号</span>
              </label>
              <input
                  type="text"
                  v-model="loginForm.user"
                  class="form-input"
                  placeholder="请输入账号"
                  autocomplete="off"
              />
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-lock"></i>
                <span>密码</span>
              </label>
              <input
                  type="password"
                  v-model="loginForm.pwd"
                  class="form-input"
                  placeholder="请输入密码"
                  autocomplete="off"
              />
            </div>

            <div class="form-options">
              <label class="checkbox-label">
                <input type="checkbox" v-model="loginForm.rememberMe"/>
                <span>记住我</span>
              </label>
              <a href="#" class="forgot-link" @click.prevent="showForgotModal = true">忘记密码?</a>
            </div>

            <button type="submit" class="login-btn" :disabled="isLoading">
              <span v-if="!isLoading">登 录</span>
              <span v-else class="loading-text">
                <i class="fas fa-spinner fa-spin"></i>
                登录中...
              </span>
            </button>
          </form>

          <!-- 注册表单 -->
          <form v-if="showRegisterForm" @submit.prevent="handleRegister" class="login-form">


            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-user"></i>
                <span>账号</span>
              </label>
              <input
                  type="text"
                  v-model="registerForm.username"
                  class="form-input"
                  placeholder="请输入账号"
                  autocomplete="off"
              />
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-lock"></i>
                <span>密码</span>
              </label>
              <input
                  type="password"
                  v-model="registerForm.password"
                  class="form-input"
                  placeholder="请输入密码"
                  autocomplete="off"
              />
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-lock"></i>
                <span>确认密码</span>
              </label>
              <input
                  type="password"
                  v-model="registerForm.confirmPassword"
                  class="form-input"
                  placeholder="请再次输入密码"
                  autocomplete="off"
              />
            </div>

            <button type="submit" class="login-btn" :disabled="isLoading">
              <span v-if="!isLoading">注 册</span>
              <span v-else class="loading-text">
                <i class="fas fa-spinner fa-spin"></i>
                注册中...
              </span>
            </button>

            <p class="form-switch">
              已有账号? <a href="#" class="switch-link" @click.prevent="showRegisterForm = false">立即登录</a>
            </p>
          </form>
        </div>
        <div class="login-footer">
          <p v-if="!showRegisterForm">还没有账号? <a href="#" class="register-link"
                                                     @click.prevent="showRegisterForm = true">立即注册</a></p>
          <p class="copyright">© 2026 AI全球播 - 智能直播中控系统</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import http from "@/utils/http";

export default {
  name: 'Login',
  data() {
    return {
      selectedPlatform: 'douyin',
      isLoading: false,
      showRegisterForm: false,
      showForgotModal: false,
      loginForm: {
        platform_type: "douyin",
        user: '',
        pwd: '',
        rememberMe: false
      },
      registerForm: {
        username: '',
        password: '',
        confirmPassword: ''
      },
      forgotForm: {
        email: ''
      }
    }
  },
  mounted() {
    const loginForm=localStorage.getItem("loginForm");

    if(loginForm){
      this.loginForm=JSON.parse(loginForm);
    }

  },
  methods: {
    async handleLogin() {
      if (!this.loginForm.user) {
        this.$dialog.tips({
          message: "请输入账号",
          type: "error"
        })
        return
      }
      if (!this.loginForm.pwd) {
        this.$dialog.tips({
          message: "请输入密码",
          type: "error"
        })
        return
      }

      const res = await http.post("api/user/login", this.loginForm);

      if (res.code == 0) {

        this.$dialog.tips({
          message: res.msg,
          type: "error"
        })
        return;
      }

      this.$dialog.tips({
        message: res.msg,
      })


      localStorage.setItem("loginForm", JSON.stringify(this.loginForm));
      localStorage.setItem("token", res.data);

      window.app.getUser();

      this.$router.push('/')


    },

    async handleRegister() {

      if (!this.registerForm.username) {
        this.$dialog.tips({
          message: "请输入账号",
          type: "error"
        })
        return
      }
      if (!this.registerForm.password) {
        this.$dialog.tips({
          message: "请输入密码",
          type: "error"
        })
        return
      }
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.$dialog.tips({
          message: "两次输入的密码不一致",
          type: "error"
        })
        return
      }

      this.isLoading = true

      const res = await http.post("api/user/reg", {
        user: this.registerForm.username,
        pwd: this.registerForm.password,
        confirmPwd: this.registerForm.confirmPassword
      })
      this.isLoading = false

      if (res.code == 200) {
        this.$dialog.tips({
          message: res.msg,
        })
        this.showRegisterForm = false
        this.registerForm = {username: '', password: '', confirmPassword: ''}
        return;
      }

      this.$dialog.tips({
        message: res.msg,
        type: "error"
      })
    },


  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0a0a0a 0%, #121218 30%, #0a0a0a 70%, #121218 100%);
  position: relative;
  overflow: hidden;
}

.background-effects {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.4;
}

.orb-1 {
  width: 400px;
  height: 400px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.5) 0%, rgba(34, 211, 238, 0.3) 100%);
  top: -100px;
  right: -100px;
  animation: float 8s ease-in-out infinite;
}

.orb-2 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.3) 0%, rgba(245, 158, 11, 0.2) 100%);
  bottom: -50px;
  left: -50px;
  animation: float 6s ease-in-out infinite reverse;
}

.orb-3 {
  width: 250px;
  height: 250px;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.3) 0%, rgba(59, 130, 246, 0.2) 100%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulseOrb 4s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(30px, -30px);
  }
}

@keyframes pulseOrb {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.4;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 0.6;
  }
}

.grid-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
  linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
}

.login-card {
  position: relative;
  width: 100%;
  max-width: 900px;
  min-height: 500px;
  background: rgba(30, 30, 35, 0.95);
  border-radius: 24px;
  display: flex;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5),
  0 0 0 1px rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  animation: cardAppear 0.6s ease-out;
}

/* 左侧品牌区域 */
.brand-section {
  flex: 1;
  padding: 50px 45px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(34, 211, 238, 0.05) 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.brand-section .logo-section {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 50px;
}

.brand-section .logo-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.4) 0%, rgba(34, 211, 238, 0.3) 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a78bfa;
  font-size: 28px;
  box-shadow: 0 10px 30px rgba(139, 92, 246, 0.4);
}

.brand-section .logo-title {
  font-size: 32px;
  font-weight: 800;
  background: linear-gradient(90deg, #ffffff 0%, #c4b5fd 30%, #a5f3fc 50%, #bbf7d0 70%, #ffffff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: 2px;
}

.brand-section .logo-subtitle {
  font-size: 12px;
  color: rgba(180, 180, 180, 0.6);
  margin: 8px 0 0 0;
  letter-spacing: 3px;
  text-transform: uppercase;
}

.brand-features {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: auto;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  color: rgba(170, 170, 170, 0.8);
  font-size: 14px;
  transition: all 0.3s ease;
}

.feature-item:hover {
  background: rgba(139, 92, 246, 0.1);
  color: #e8e8e8;
  transform: translateX(5px);
}

.feature-item i {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(34, 211, 238, 0.1) 100%);
  border-radius: 10px;
  color: #a78bfa;
}

/* 左侧平台选择样式 */
.brand-section .platform-section {
  margin: 30px 0;
}

.brand-section .platform-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.brand-section .platform-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 12px 8px;
  background: rgba(50, 50, 60, 0.5);
  border: 2px solid transparent;
  border-radius: 12px;
  color: rgba(170, 170, 170, 0.8);
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 11px;
}

.brand-section .platform-btn:hover {
  background: rgba(139, 92, 246, 0.1);
  border-color: rgba(139, 92, 246, 0.3);
  transform: translateY(-2px);
}

.brand-section .platform-btn.active {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(34, 211, 238, 0.1) 100%);
  border-color: rgba(139, 92, 246, 0.5);
  color: #e8e8e8;
  box-shadow: 0 0 20px rgba(139, 92, 246, 0.2);
}

.brand-section .platform-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background: rgba(255, 255, 255, 0.05);
  color: #a78bfa;
  border: 1px solid rgba(139, 92, 246, 0.2);
}

.brand-section .douyin-icon {
  background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%);
  color: #ffffff;
}

.brand-section .douyin-tg-icon {
  background: linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%);
  color: #ffffff;
}

.brand-section .kuaishou-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #ef4444 100%);
  color: #ffffff;
}

.brand-section .kuaishou-tg-icon {
  background: linear-gradient(135deg, #f97316 0%, #fbbf24 100%);
  color: #ffffff;
}

.brand-section .weixin-icon {
  background: linear-gradient(135deg, #10b981 0%, #3b82f6 100%);
  color: #ffffff;
}

.brand-section .pinduoduo-icon {
  background: linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%);
  color: #ffffff;
}

.brand-section .taobao-icon {
  background: linear-gradient(135deg, #f43f5e 0%, #fb923c 100%);
  color: #ffffff;
}

.brand-section .meituan-icon {
  background: linear-gradient(135deg, #06b6d4 0%, #10b981 100%);
  color: #ffffff;
}

.brand-section .jd-icon {
  background: linear-gradient(135deg, #ef4444 0%, #6366f1 100%);
  color: #ffffff;
}

.brand-section .tiktok-icon {
  background: linear-gradient(135deg, #1e1b4b 0%, #4338ca 100%);
  color: #ffffff;
}

/* 右侧登录区域 */
.login-section {
  flex: 1;
  padding: 50px 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.logo-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(34, 211, 238, 0.2) 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a78bfa;
  font-size: 24px;
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.3);
}

.logo-title {
  font-size: 28px;
  font-weight: 800;
  background: linear-gradient(90deg, #ffffff 0%, #c4b5fd 30%, #a5f3fc 50%, #bbf7d0 70%, #ffffff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: 2px;
}

.logo-subtitle {
  font-size: 12px;
  color: rgba(180, 180, 180, 0.6);
  margin: 8px 0 0 0;
  letter-spacing: 3px;
  text-transform: uppercase;
}

.login-form {
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: rgba(170, 170, 170, 0.9);
  margin-bottom: 8px;
  font-weight: 500;
}

.form-label i {
  color: rgba(139, 92, 246, 0.8);
}

.form-input {
  width: 100%;
  padding: 14px 18px;
  background: rgba(25, 25, 30, 0.9);
  border: 1px solid rgba(170, 170, 170, 0.15);
  border-radius: 12px;
  color: #e8e8e8;
  font-size: 15px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: rgba(139, 92, 246, 0.5);
  box-shadow: 0 0 20px rgba(139, 92, 246, 0.15);
}

.form-input::placeholder {
  color: #555;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(170, 170, 170, 0.8);
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #8b5cf6;
}

.forgot-link {
  font-size: 13px;
  color: rgba(139, 92, 246, 0.8);
  text-decoration: none;
}

.forgot-link:hover {
  color: #a78bfa;
}

.login-btn {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.25) 0%, rgba(34, 211, 238, 0.15) 100%);
  border: 1px solid rgba(139, 92, 246, 0.4);
  border-radius: 12px;
  color: #c4b5fd;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.login-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.35) 0%, rgba(34, 211, 238, 0.25) 100%);
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.3);
  transform: translateY(-2px);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.loading-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.login-footer {
  text-align: center;
}

.login-footer p {
  font-size: 13px;
  color: rgba(170, 170, 170, 0.6);
  margin: 8px 0;
}

.register-link {
  color: rgba(139, 92, 246, 0.9);
  text-decoration: none;
}

.register-link:hover {
  color: #a78bfa;
}

.copyright {
  font-size: 11px !important;
  letter-spacing: 1px;
}

/* 表单切换链接 */
.form-switch {
  text-align: center;
  margin-top: 16px;
  font-size: 13px;
  color: rgba(170, 170, 170, 0.7);
}

.switch-link {
  color: rgba(139, 92, 246, 0.9);
  text-decoration: none;
}

.switch-link:hover {
  color: #a78bfa;
}

/* 弹窗遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  width: 100%;
  max-width: 400px;
  background: rgba(30, 30, 35, 0.98);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #e8e8e8;
  margin: 0;
}

.modal-close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  border-radius: 8px;
  color: rgba(170, 170, 170, 0.8);
  cursor: pointer;
  transition: all 0.3s ease;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #e8e8e8;
}

.modal-body {
  padding: 24px;
}

.modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.modal-btn {
  flex: 1;
  padding: 12px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.modal-btn.cancel-btn {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(170, 170, 170, 0.9);
}

.modal-btn.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.modal-btn.submit-btn {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.25) 0%, rgba(34, 211, 238, 0.15) 100%);
  border: 1px solid rgba(139, 92, 246, 0.4);
  color: #c4b5fd;
}

.modal-btn.submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.35) 0%, rgba(34, 211, 238, 0.25) 100%);
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.3);
}

.modal-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .login-card {
    flex-direction: column;
    max-width: 420px;
    min-height: auto;
    margin: 20px;
  }

  .brand-section {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    padding: 35px 30px;
  }

  .brand-section .logo-section {
    margin-bottom: 25px;
  }

  .brand-features {
    margin-top: 25px !important;
  }

  .login-section {
    padding: 35px 30px;
  }

  .brand-section .platform-grid {
    grid-template-columns: repeat(5, 1fr);
    gap: 8px;
  }

  .brand-section .platform-btn {
    padding: 10px 6px;
    font-size: 10px;
  }

  .brand-section .platform-icon {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
}
</style>